import React from "react"
import { InputNumber as PrimeInputNumber } from "primereact/inputnumber"

export default React.forwardRef((props, ref) => {
  return <PrimeInputNumber ref={ref} {...props} />
})
